import axios from 'axios';
import { fetchToken } from '../fetchToken';
import { logError } from '../../taskpane/utils/request';
const API_URL = process.env.EMAILS_API_URL;

/**
 * Queue a Doc Assistant capture for the given email.
 * @param {string} emailId Outlook/Graph id of the email to capture
 * @return {Promise} api response (202 when queued)
 */
export const postDocAssistantCapture = async (emailId) => {
  const token = await fetchToken();
  const config = {
    method: 'POST',
    url: `${API_URL}doc-assistant/capture`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: { emailId },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

/**
 * Read the capture state of a previously queued Doc Assistant email.
 * @param {string} emailId Outlook/Graph id of the captured email
 * @return {Promise} api response with { status, matches }
 */
export const getDocAssistantCaptureStatus = async (emailId) => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: `${API_URL}doc-assistant/capture/status?emailId=${encodeURIComponent(emailId)}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

/**
 * Assign a captured Doc Assistant email to one or more records.
 * @param {object} params { externalId, relatedTos, filesAlreadyAssigned }
 *   relatedTos is a list of { relatedToId, relatedToApiName }; attachments are matched independently,
 *   so a capture can resolve to several matters.
 *   filesAlreadyAssigned signals that Document Assistant already reparented the matched attachments;
 *   the backend then only moves the .eml to the primary matter instead of reparenting every file.
 * @return {Promise} api response
 */
export const postDocAssistantAssign = async ({ externalId, relatedTos, filesAlreadyAssigned }) => {
  const token = await fetchToken();
  const config = {
    method: 'POST',
    url: `${API_URL}doc-assistant/assign`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: { externalId, relatedTos, ...(filesAlreadyAssigned && { filesAlreadyAssigned: true }) },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};
